<template>
  <lk-modal
    v-model="modalShow"
    :closable='false'
    :mask-closable='false'
    width="420"
    title="新建活动"
    >
    <div class="container">
      <lk-form
        :label-width="80"
        ref="promotionForm"
        :model='info'
        :rules="promotionValidate"
      >
        <lk-form-item label="活动类型:" prop="promoteType">
          <lk-select v-model="info.promoteType">
            <lk-option v-for="item in promoteTypeList"
            :key="item.id"
            :value='item.id'>{{item.name}}</lk-option>
          </lk-select>
        </lk-form-item>
        <lk-form-item label="活动门店:" prop="storeId">
          <lk-select
            v-model="info.storeId"
            filterable
          >
            <lk-option v-for="item in promotionStores"
            :key="item.id"
            :value='item.id'>{{item.name}}</lk-option>
          </lk-select>
        </lk-form-item>
      </lk-form>
    </div>
    <div slot="footer">
      <lk-button type='primary' @click="onConfirm">确定</lk-button>
      <lk-button class="cancel" @click="closeModal" >取消</lk-button>
    </div>
  </lk-modal>
</template>
<script>
import mapState from '@/mixins/mapState';
import service from '@/services/system';
import utils from '@/libs/utils'

export default {
  name: 'addNewModal',
  mixins: [mapState],
  data() {
    return {
      promotionStores: [], // 活动门店
      info: {
        promoteType:null,
        storeId: null,
      },
      promoteTypeList: [
        {
          name: '商品促销',
          id: 1,
        },
        {
          name: '买减/买折',
          id: 2,
        },
      ],
      modalShow: false,

      promotionValidate: {
        promoteType: [
          {
            required: true,
            message: '请选择活动类型',
            trigger: 'change',
            type: 'number',
          },
        ],
        storeId: [
          {
            required: true,
            message: '请选择活动门店',
            trigger: 'change',
            type: 'number',
          },
        ],
      }
    };
  },
  props: {
    val: {
      type: Boolean,
    },
  },
  model: {
    prop: 'val',
    event: 'change',
  },
  watch: {
    val(val) {
      this.modalShow = val;
      this.modalShow ? this.getStores() : null;
    },
  },
  methods: {
    onConfirm() {
      this.$refs.promotionForm.validate(valid => {
        if (valid) {
          this.setModal(false);
          const { promoteType, storeId } = this.info;
          this.$router.push({ name: 'promotionNew', params: { promoteType, storeId }});
        }
      })
    },
    setModal(val) {
      this.modalShow = val;
      this.$emit('change', this.modalShow);
    },
    closeModal() {
      this.setModal(false);
    },
    getStores() {
      service.getBelongStores().then((res) => {
        this.promotionStores = [];
        if (res.data.status === 200) {
          this.promotionStores = res.data.data;
          if (res.data.data.length > 1) {  // 根据长度来判断是否是总部或者当前门店
            const obj = {
              name: '全部门店',
              id: 0,
            }
            this.promotionStores.unshift(obj);
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    }
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.container{
  padding-right: 42px;
  padding-left: 16px;
  padding-top:8px;
}
</style>
